import { useAppNavigate, useCurrentUser } from '_graphql/cache/auth';
import { Modal, OfficeButton, toast } from 'components';
import { FC } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { requestPayout } from '_graphql/mutation/payment';
import PayoutForm from './forms/payour';
import { useMutation } from '@apollo/client';
import { CurrencyCode, MakeWalletWithdrawalMutation, MakeWalletWithdrawalMutationVariables } from '_graphql/mutation/__generated__/graphql';
import { useSupplierWallets } from './hooks/use-wallet';
import { randomString } from 'utils/helpers';
import { useSupplier } from 'pages/settings/hooks/use-supplier';

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
};

const validationSchema = yup.object().shape({
  amount: yup
    .number()
    .typeError('Must be a number')
    .min(1, 'Minimum of 1')
    .required('Amount is required'),
});

const CreatePayoutContainer: FC<Props> = ({ setOpen, open }) => {
  const currentUser = useCurrentUser();
  const { wallets } = useSupplierWallets({
    // userId: currentUser?.id,
    userId: currentUser?.supplierSignIn?.supplier?.id as string,
  });

  const navigate = useAppNavigate();
  const [initiate, { loading }] = useMutation<
    MakeWalletWithdrawalMutation,
    MakeWalletWithdrawalMutationVariables
  >(requestPayout, {
    refetchQueries: ['GetWalletPayouts'],
  });

  const { supplier } = useSupplier();

  const form = useFormik({
    initialValues: {
      amount: 0,
    },
    validationSchema,
    onSubmit: (values) => {
      initiate({
        variables: {
          input: {
            amount: Number(values.amount),
            currency: {
              code: wallets[0]?.currency.code as CurrencyCode,
              name: wallets[0]?.currency.name as string,
            },
            wallet_id: wallets[0]?.id as string,
            secret: randomString(7),
            provider: {
              account_name: supplier?.payment_details?.account_name || '',
              account_number: supplier?.payment_details?.account_number || '',
              name: supplier?.payment_details?.provider || '',
            },
          },
        },
      })
        .then(({ data }) => {
          if (data?.makeWalletWithdrawal.status !== 'failed') {
            toast('Payoout Request created successfully', 'success');
          } else {
            toast((data?.makeWalletWithdrawal.error as string) ?? '', 'error');
          }
        })
        .catch((err) => {
          toast(err?.message, 'error');
        });
    },
  });

  return (
    <Modal
      open={open}
      setOpen={() => {
        setOpen(false);
        navigate({
          search: (old) => ({
            ...old,
            modal: undefined,
            id: undefined,
          }),
        });
      }}
      title="Request Payout"
      description=""
      renderActions={() => (
        <OfficeButton ml onClick={form.handleSubmit}>
          {loading ? 'Requesting...' : 'Request'}
        </OfficeButton>
      )}
    >
      <PayoutForm form={form} />
    </Modal>
  );
};

export default CreatePayoutContainer;
